import React, { useState } from 'react';
import { topScorers } from '../mock/mockData';
import { Trophy, Target } from 'lucide-react';

const TopSkor = () => {
  const [categoryFilter, setCategoryFilter] = useState('U-14');

  const filteredScorers = topScorers.filter((scorer) => scorer.category === categoryFilter);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="flex items-center space-x-3 mb-8">
          <Trophy className="h-10 w-10 text-green-600" />
          <h1 className="text-4xl font-bold text-gray-900">Top Skor</h1>
        </div>

        {/* Category Filter */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Kategori
          </label>
          <select
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
            className="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent"
          >
            <option value="U-12">U-12</option>
            <option value="U-14">U-14</option>
          </select>
        </div>

        {/* Top 3 Scorers - Special Display */}
        {filteredScorers.length >= 3 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {/* 2nd Place */}
            <div className="order-2 md:order-1">
              <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg p-6 text-center transform md:translate-y-8">
                <div className="flex justify-center mb-4">
                  <Trophy className="h-16 w-16 text-gray-400" />
                </div>
                <div className="bg-gray-300 w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <span className="text-2xl font-bold text-gray-700">2</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{filteredScorers[1].name}</h3>
                <p className="text-gray-600 mb-4">{filteredScorers[1].team}</p>
                <div className="flex items-center justify-center space-x-2">
                  <Target className="h-5 w-5 text-gray-600" />
                  <span className="text-3xl font-bold text-gray-700">{filteredScorers[1].goals}</span>
                </div>
                <p className="text-sm text-gray-500 mt-2">{filteredScorers[1].matches} pertandingan</p>
              </div>
            </div>

            {/* 1st Place */}
            <div className="order-1 md:order-2">
              <div className="bg-gradient-to-br from-yellow-100 to-yellow-200 rounded-lg p-6 text-center">
                <div className="flex justify-center mb-4">
                  <Trophy className="h-20 w-20 text-yellow-500" />
                </div>
                <div className="bg-yellow-400 w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <span className="text-3xl font-bold text-yellow-900">1</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{filteredScorers[0].name}</h3>
                <p className="text-gray-700 mb-4 font-semibold">{filteredScorers[0].team}</p>
                <div className="flex items-center justify-center space-x-2">
                  <Target className="h-6 w-6 text-yellow-700" />
                  <span className="text-4xl font-bold text-yellow-700">{filteredScorers[0].goals}</span>
                </div>
                <p className="text-sm text-gray-600 mt-2">{filteredScorers[0].matches} pertandingan</p>
              </div>
            </div>

            {/* 3rd Place */}
            <div className="order-3">
              <div className="bg-gradient-to-br from-orange-100 to-orange-200 rounded-lg p-6 text-center transform md:translate-y-8">
                <div className="flex justify-center mb-4">
                  <Trophy className="h-16 w-16 text-orange-600" />
                </div>
                <div className="bg-orange-400 w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <span className="text-2xl font-bold text-orange-900">3</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{filteredScorers[2].name}</h3>
                <p className="text-gray-600 mb-4">{filteredScorers[2].team}</p>
                <div className="flex items-center justify-center space-x-2">
                  <Target className="h-5 w-5 text-orange-600" />
                  <span className="text-3xl font-bold text-orange-700">{filteredScorers[2].goals}</span>
                </div>
                <p className="text-sm text-gray-500 mt-2">{filteredScorers[2].matches} pertandingan</p>
              </div>
            </div>
          </div>
        )}

        {/* All Scorers Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-green-600 text-white">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Peringkat</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Nama Pemain</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold">Tim</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold">Gol</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold">Pertandingan</th>
                  <th className="px-4 py-3 text-center text-sm font-semibold">Rata-rata</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredScorers.map((scorer) => (
                  <tr
                    key={scorer.id}
                    className={`hover:bg-gray-50 transition-colors ${
                      scorer.position <= 3 ? 'bg-green-50' : ''
                    }`}
                  >
                    <td className="px-4 py-4">
                      <div className="flex items-center space-x-2">
                        <span className="font-bold text-gray-900 w-8">{scorer.position}</span>
                        {scorer.position === 1 && (
                          <Trophy className="h-5 w-5 text-yellow-500" />
                        )}
                        {scorer.position === 2 && (
                          <Trophy className="h-5 w-5 text-gray-400" />
                        )}
                        {scorer.position === 3 && (
                          <Trophy className="h-5 w-5 text-orange-600" />
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <span className="font-semibold text-gray-900">{scorer.name}</span>
                    </td>
                    <td className="px-4 py-4">
                      <span className="text-gray-700">{scorer.team}</span>
                    </td>
                    <td className="px-4 py-4 text-center">
                      <span className="font-bold text-green-600 text-lg">{scorer.goals}</span>
                    </td>
                    <td className="px-4 py-4 text-center text-gray-700">{scorer.matches}</td>
                    <td className="px-4 py-4 text-center">
                      <span className="font-semibold text-gray-700">
                        {(scorer.goals / scorer.matches).toFixed(2)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSkor;